import { inputAnatomy } from '@chakra-ui/anatomy';
import { createMultiStyleConfigHelpers, defineStyle } from '@chakra-ui/react';
import { variantFilled, variantFlushed, variantOutlined } from '../../focusShim';
const {
  definePartsStyle,
  defineMultiStyleConfig
} = createMultiStyleConfigHelpers(inputAnatomy.keys);
const baseStyle = definePartsStyle({
  field: {
    // I don't know why I can't just use borderColor
    borderTopColor: 'GREYSCALE.MILKY_WAY !important',
    borderRightColor: 'GREYSCALE.MILKY_WAY !important',
    borderBottomColor: 'GREYSCALE.MILKY_WAY !important',
    borderLeftColor: 'GREYSCALE.MILKY_WAY !important',
    borderRadius: 'full'
  }
});
const xl = defineStyle({
  fontSize: 'lg',
  px: '4',
  h: '14',
  borderRadius: 'lg'
});
const sizes = {
  xl: definePartsStyle({
    field: xl,
    addon: xl
  })
};
const highlighted = definePartsStyle({
  field: {
    border: '1px solid',
    // I don't know why I can't just use borderColor
    borderTopColor: 'CARNABY.light !important',
    borderRightColor: 'CARNABY.light !important',
    borderBottomColor: 'CARNABY.light !important',
    borderLeftColor: 'CARNABY.light !important'
  }
});
const pill = definePartsStyle({
  field: {
    borderRadius: 'full',
    border: '1px solid',
    _focus: variantOutlined()
  }
});
const filled = definePartsStyle(() => {
  return {
    field: {
      backgroundColor: 'GREYSCALE.SUPERNOVA',
      border: 'none',
      _focus: Object.assign({
        backgroundColor: 'GREYSCALE.SUPERNOVA'
      }, variantFilled()),
      _invalid: {
        border: '1px solid',
        borderColor: 'KYOTO.regular !important'
      }
    }
  };
});
const outline = definePartsStyle(() => {
  return {
    field: {
      _focus: variantOutlined()
    }
  };
});
const flushed = definePartsStyle(() => {
  return {
    field: {
      _focus: variantFlushed()
    }
  };
});
export default defineMultiStyleConfig({
  baseStyle,
  variants: {
    highlighted,
    pill,
    filled,
    outline,
    flushed
  },
  sizes
});